import { useMutation, useQueryClient } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useUpdateExperienceState = function () {
    var axios = useAxios();
    var queryClient = useQueryClient();
    return useMutation(function (values) {
        return axios.request({
            method: 'PUT',
            data: values,
            url: "/api/v1/experience_state",
        });
    }, {
        onSuccess: function (_a, variables) {
            var data = _a.data;
            queryClient.invalidateQueries('experience-state');
        },
    });
};
